define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/action/Switchboard",
	"csi/core/ExtendedPath",
	"csi/def/Action",
	"csi/def/Heading",
	"csi/core/Key",
	"csi/reflection",
	"csi/table/Preferences",
	"../_Increment",
	"../SizeChart",
	"./IncrementDimension2SizesSwitchboard",
	"./Table"
], function(declare, lang, _, SwitchboardAction, ExtendedPath, Action, Heading, Key, reflection, Preferences, _Increment, SizeChart, IncrementDimension2SizesSwitchboard, Table) {

	var _Preferences = declare(Preferences, {
		constructor: function() {
			this.addCustomOption("sizeChartUnits", SizeChart.valueUnits, false, "SizeChartUnits");
			this.addCustomOption("sizeChartDisplay", SizeChart.gradingDefaultDisplay, false, "SizeChartDisplay");
		}
	});

	return declare(Table, {
		prefClass: _Preferences,
		_incrementData: null,

		displayTwoDimension: function(/*Node*/dimension) {
			// summary: returns boolean if the IncrementDimension is displayed as 2-d matrix
			var incrementData = this.getIncrementData();
			if (_.isEmpty(incrementData.dim2Sizes)) {
				return false;
			}

			var apparelDimension = this.cacheView.getNode(dimension.IncrementDimension);
			return apparelDimension && _.contains(apparelDimension.DimensionDependencies, incrementData.getDimension2Type());
		},

		getIncrementData: function() {
			if (!this._incrementData) {
				var incrementNode = this.getViewNode();
				this._incrementData = new _Increment(this.cacheView, incrementNode);
			}

			return this._incrementData;
		},

		/**
		 * @override
		 * Update view for 1d vs 2d sizes
		 */
		_resolveColumns() {
			const isTwoDim = this._isTwoDim();
			const incrHeading = this.defView.findHeading("Increments");
			if (incrHeading) {
				incrHeading.getMatrixProcessor().columnPath = isTwoDim ? "Child:IncrementDimension1Sizes" : "Child:Sizes";
			}

			this.inherited(arguments);

			// add USSize to the Increment matrix
			if (!isTwoDim) {
				const spec = this.getHeadingSpec(new Key({
					extendedPath: new ExtendedPath("IncrementSize"),
					id: "USSize"
				}));

				this.set("columnNodeSpec", spec);
			}
		},

		_resolveView: function() {
			// summary: update view configuration based on context

			var tb = this.defView.defToolbar;

			// TA31796: if Increment is on 2-d, add a Multi-select dropdown so that users can filter out the 2nd dimension(s) as desired
			tb.addAction(lang.mixin(new Action(), {m_id: "|"}), 0);
			tb.addAction(lang.mixin(new SwitchboardAction(), {
				classToolbarPlugin: IncrementDimension2SizesSwitchboard,
				m_id: "SelectIncrementDimension2Sizes"
			}), 0);

			this.inherited(arguments);
		},

		_isTwoDim: function() {
			// return boolean true if the parent Increment has two dimensional sizes
			var dimension2Sizes = this.getViewNode().IncrementDimension2Sizes;
			return dimension2Sizes && dimension2Sizes.length > 0;
		}
	});
});